var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid d-flex flex-wrap justify-content-between"},[_c('nav',[_c('ul',{staticClass:"footer-menu"},[_c('li',[_c('span',{staticClass:"btn btn-link"},[_vm._v(" "+_vm._s(_vm.version)+" ")])])])]),_c('div',{staticClass:"copyright"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }